import { render, staticRenderFns } from "./Comment.vue?vue&type=template&id=0909c290&scoped=true&"
import script from "./Comment.vue?vue&type=script&lang=js&"
export * from "./Comment.vue?vue&type=script&lang=js&"
import style0 from "./Comment.vue?vue&type=style&index=0&id=0909c290&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0909c290",
  null
  
)

export default component.exports